import { render, staticRenderFns } from "./ZoneTerritoryUpdate.vue?vue&type=template&id=24d669e4&"
import script from "./ZoneTerritoryUpdate.vue?vue&type=script&lang=ts&"
export * from "./ZoneTerritoryUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports